export enum LanguageList {
  EN = 'EN',
  RU = 'RU',
  CN = 'CN',
}

export enum LanguageAlias {
  EN = 'English',
  RU = 'Russian',
  CN = 'Chinese',
}
